module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_vestfold_telemark_neg.41fd4d12.pdf";